<script setup lang="ts">
  import SelectQC from '@qicgroupdoha/qic-connect-ds/components/SelectQC'
  import WrapperQC from '@qicgroupdoha/qic-connect-ds/components/WrapperQC'
  import { useI18n } from 'vue-i18n'

  interface Props {
    modelValue: string | null | undefined
    maritalStatuses: Array<{ code: string; name: string }>
    errors?: string[]
    isValid: boolean
  }

  const { locale } = useI18n()
  defineProps<Props>()
  defineEmits<{ (e: 'update:modelValue', value: string): void }>()
</script>

<template>
  <WrapperQC direction="column">
    <!-- @vue-ignore -->
    <SelectQC
      :model-value="modelValue"
      :options="maritalStatuses"
      :label="$t('visitors.fill_visitors_info.marital_status_placeholder')"
      :is-valid="isValid"
      :errors="errors"
      :container-attrs="{ 'data-test': 'marital-status-select' }"
      title-key="name"
      value-key="code"
      name="maritalStatus"
      :mobile-version="false"
      data-test="marital-status-select"
      :locale="locale"
      @update:model-value="$emit('update:modelValue', $event)"
    />
  </WrapperQC>
</template>
